import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

export default function VisitsMapModal({ open, onClose, visits }) {
  if (!open) return null;

  const points = visits
    .filter(v => typeof v.lat === "number" && typeof v.lng === "number")
    .map(v => [v.lat, v.lng]);

  if (points.length === 0) {
    return (
      <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
        <div className="bg-white p-4 rounded-lg">
          <p>No valid locations to display</p>
          <button onClick={onClose} className="mt-3 px-3 py-1 border rounded">
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
      <div className="bg-white w-[90vw] h-[85vh] rounded-xl shadow-lg flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-2 border-b">
          <h2 className="font-semibold text-lg">Visits Map</h2>
          <button onClick={onClose} className="text-sm px-2 py-1 border rounded">
            Close
          </button>
        </div>

        {/* Map */}
        <div className="flex-1">
          <MapContainer
            center={points[0]}
            zoom={13}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              attribution="© OpenStreetMap"
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            <Polyline positions={points} color="#2563EB" weight={4} />

            {visits.map(v => (
              <Marker key={v.id} position={[v.lat, v.lng]}>
                <Popup>
                  <div className="text-sm">
                    <b>{v.customer_name}</b><br />
                    {v.salesperson_name}<br />
                    {new Date(v.when).toLocaleTimeString()}<br />
                    {v.distance_km ?? 0} km
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
    </div>
  );
}
